import { RoundFloat } from "../services/common"

export default function StatEffect(data, tww_version) {
    this.tww_version = tww_version;

    this.phase = data.phase;
    this.stat = data.stat;
    this.value = RoundFloat(data.value);
    this.how = data.how;
}